import React from "react";
import SectionState from "../../shared/SectionState";
import AnalyticsFiltersBar from "./AnalyticsFiltersBar";
import AnalyticsKpiCards from "./AnalyticsKpiCards";
import AnalyticsTimeSeriesChart from "./AnalyticsTimeSeriesChart";
import AnalyticsActionsBreakdown from "./AnalyticsActionsBreakdown";
import AnalyticsWorkspaceComparison from "./AnalyticsWorkspaceComparison";
import AnalyticsTranslationHealthPanel from "./AnalyticsTranslationHealthPanel";
import AnalyticsBranchActivityPanel from "./AnalyticsBranchActivityPanel";
import { useRepositoryAnalytics } from "../hooks/useRepositoryAnalytics";

interface AnalyticsDashboardProps {
  owner: string;
  repo: string;
  workspaceKey: string;
}

const AnalyticsDashboard = ({ owner, repo, workspaceKey }: AnalyticsDashboardProps) => {
  const {
    filters,
    setFilters,
    summary,
    timeseries,
    actions,
    workspaces,
    translationHealth,
    branches,
    isLoading,
    errorText,
    refresh,
  } = useRepositoryAnalytics({ owner, repo, workspaceKey });

  return (
    <section className="space-y-3">
      <AnalyticsFiltersBar filters={filters} isLoading={isLoading} onChange={setFilters} onRefresh={refresh} />
      <SectionState
        isLoading={isLoading}
        errorText={errorText}
        isEmpty={!summary}
        emptyText="No analytics data for selected filters."
      >
        <div className="space-y-3">
          <AnalyticsKpiCards summary={summary} />
          <div className="grid grid-cols-1 gap-3 xl:grid-cols-2">
            <AnalyticsTimeSeriesChart timeseries={timeseries} />
            <AnalyticsActionsBreakdown actions={actions} />
          </div>
          <div className="grid grid-cols-1 gap-3 xl:grid-cols-2">
            <AnalyticsWorkspaceComparison workspaces={workspaces} />
            <AnalyticsTranslationHealthPanel health={translationHealth} />
          </div>
          <AnalyticsBranchActivityPanel branches={branches} />
        </div>
      </SectionState>
    </section>
  );
};

export default AnalyticsDashboard;
